<template>
  <!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
  <b-button
    :type="type"
    :size="size"
    :label="label"
    :loading="loading"
    :outlined="outlined"
    :active="active"
    :expanded="expanded"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :icon-pack="iconPack"
    :tag="tag"
    :disabled="disabled"
    @click.native="handleClick"
  >
    <slot />
  </b-button>
  <!-- eslint-enable vue/no-deprecated-v-on-native-modifier -->
</template>

<script>
import { ButtonSize } from '@/modules/core/app/enums/button/ButtonSize';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ButtonView',
  emits: ['click'],
  props: {
    type: {
      type: String
    },
    size: {
      type: String,
      validator: (prop) => Object.values(ButtonSize).includes(prop)
    },
    label: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    iconLeft: {
      type: String
    },
    iconRight: {
      type: String
    },
    iconPack: {
      type: String,
      default: 'cls'
    },
    tag: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(...args) {
      this.$emit('click', ...args);
    }
  }
};
</script>
